module.exports = __webpack_public_path__ + "static/scale-model-of-omaha's-henry-doorly-zoo-and-aquarium-in-omaha-nebraska-026d108564de0d639252baf5bf8b3cf9.png";